export const listOfCerts = [
  {
    title: 'Meta Front-End Developer',
    subtitle: 'Website',
    link: 'https://coursera.org/share/d4266393c64d87075521ae1da4d0de3b',
    image: 'meta_front-end_dev.webp',
    date: '02-23-2024',
    desc: `This is my certification I received from Meta for completing 
    their entire Front-End Development course.`,
  },
  {
    title: 'Principles of UX/UI Design',
    subtitle: 'Website',
    link: 'https://coursera.org/share/798ec8da9f13149293aa0ea47a533e10',
    image: 'ux_ui.webp',
    date: '02-02-2024',
    desc: `This is my certification from a renowned institution for completing
      their Principles of UX/UI Design course. This course provided me with 
      a comprehensive understanding of user experience and interface design 
      principles, teaching me how to apply these concepts to create intuitive 
      and user-friendly digital products.`,
  },
  {
    title: 'Advanced React',
    subtitle: 'Website',
    link: 'https://coursera.org/share/966659fc5ebd7103adbbcf07da57530a',
    image: 'advanced_react.webp',
    date: '01-31-2024',
    desc: `This is my certification from Meta, acknowledging my completion 
      of their Advanced React course. This course provided an in-depth 
      exploration of React, equipping me with advanced skills and techniques 
      essential for developing complex and dynamic web applications. It covered 
      advanced topics such as state management, hooks, context API, and performance 
      optimization, enabling me to create more efficient and sophisticated web apps.`,
  },
  {
    title: 'React Basics',
    subtitle: 'Website',
    link: 'https://coursera.org/share/3d0cbcdeb29db7444aa205453d4370ad',
    image: 'react_basics.webp',
    date: '01-26-2024',
    desc: `This is my certification I received from Meta for completing their React Basics course.
       This course taught me the basics of React and how to use it to create a web app.`,
  },
  {
    title: 'HTML and CSS in Depth',
    subtitle: 'Website',
    link: 'https://coursera.org/share/a8d5ebf2db1447fc6e549d03135e3b3e',
    image: 'html_css.webp',
    date: '01-25-2024',
    desc: `This is my certification I received from Meta for completing their HTML and 
      CSS in depth course. This course took a deep dive into the web development 
      languages HTML and CSS. I learned how to be proficient in both languages 
      and how to use them to create a website.`,
  },
  {
    title: 'Programming with JavaScript',
    subtitle: 'Website',
    link: 'https://coursera.org/share/daaee25068cc66ef91a3f2dc1d329c7f',
    image: 'programing_js.webp',
    date: '01-21-2024',
    desc: `This is my certification I received from Meta for completing their 
      Programming with JavaScript course. This course introduced me Javascript 
      and refreshed me memory on the fundamentals of programming.`,
  },
  {
    title: 'Version Control',
    subtitle: 'Website',
    link: 'https://coursera.org/share/2174b5337404f8f4ebc1c0280b0c281d',
    image: 'version_control.webp',
    date: '01-22-2024',
    desc: `This is my certification I received from Meta for completing their 
      Introduction to Front-End Development course. This course introduced 
      me to Version Control systems and refreshed me memory of Git, Github, Bash.`,
  },
  {
    title: 'Introduction to Front-End Development',
    subtitle: 'Website',
    link: 'https://coursera.org/share/51f14261dbec426eb331a39fa3198b9b',
    image: 'introducrion_to_front-end.webp',
    date: '01-18-2024',
    desc: `This is my certification I received from Meta for completing their 
      Introduction to Front-End Development course. This course introduced 
      me to Front-End Development and taught me the basics of HTML, CSS, and JavaScript.`,
  },
  {
    title: 'Meta React Native',
    subtitle: 'Website',
    link: 'https://coursera.org/share/88d9bf7714a28ad7310a8ffaa7d0ec79',
    image: 'meta_react_native.webp',
    date: '02-14-2024',
    desc: `This certification from the Meta React Native course signifies my proficiency in 
    building cross-platform mobile applications using React Native. It covers the essentials 
    of developing efficient Android and iOS apps, emphasizing practical skills for creating 
    responsive and user-friendly mobile experiences.`,
  },
  {
    title: 'React Native',
    subtitle: 'Website',
    link: 'https://coursera.org/share/acd7a3bb1715bf52bf8f9a024b0b5957',
    image: 'react_native.webp',
    date: '02-12-2024',
    desc: `This certification demonstrates my mastery of React Native, 
    focusing on developing high-performance mobile applications for 
    both Android and iOS. The course provided in-depth knowledge on 
    utilizing React Native for creating intuitive and responsive user 
    interfaces, enabling me to craft seamless cross-platform mobile experiences.`,
  },
  {
    title: 'Working with Data',
    subtitle: 'Website',
    link: 'https://coursera.org/share/8a824889ef739f3ed1ab833d07d1568f',
    image: 'data.webp',
    date: '02-14-2024',
    desc: `This certification, 'Working with Data', underlines my capabilities 
    in handling, analyzing, and visualizing data effectively. The course offered 
    comprehensive insights into data manipulation techniques, databases, and data 
    visualization tools, equipping me with the essential skills to derive meaningful 
    insights from complex datasets and inform decision-making processes.`,
  },
  {
    title: 'Introduction to Mobile Development',
    subtitle: 'Website',
    link: 'https://coursera.org/share/7bbd5c2d776d98bcf7189f402f8cbafb',
    image: 'intro_to_mobile_dev.webp',
    date: '02-12-2024',
    desc: `This certification from the 'Introduction to Mobile Development' 
    course marks my foundational understanding of mobile app development, 
    covering essential concepts and practical skills for designing and 
    building mobile applications. The program provided a broad overview 
    of mobile development frameworks and principles, laying the groundwork 
    for creating engaging and user-centric mobile experiences on various platforms.`,
  },
];
